import React, { useEffect, useState } from 'react';
import { MONTH_NAMES } from '@go-shared/lib/time';
import './MonthSelector.scss';
import { BubbleButton } from '@go-client/components/BubbleUI';

interface MonthSelectorProps {
  onMonthChanged: (newMonth: number) => void;
  month: number;
}

export const MonthSelector: React.FC<MonthSelectorProps> = ({ onMonthChanged, month }) => {
  const [selectedMonth, setSelectedMonth] = useState<number>(month);

  useEffect(() => {
    if (!isNaN(month)) {
      setSelectedMonth(month);
    }
  }, [month]);

  const previousMonth = () => {
    if (selectedMonth > 0) {
      setSelectedMonth(selectedMonth - 1);
      onMonthChanged(selectedMonth - 1);
    }
  };
  const nextMonth = () => {
    if (selectedMonth < MONTH_NAMES.length - 1) {
      setSelectedMonth(selectedMonth + 1);
      onMonthChanged(selectedMonth + 1);
    }
  };

  return (
    <div className="flex items-center">
      <div
        className="grid grid-cols-3 items-stretch rounded-lg overflow-hidden"
        style={{ gridTemplateColumns: 'auto 1fr auto' }}
      >
        <BubbleButton
          block
          variant="lime"
          appearance="squared"
          onClick={previousMonth}
          icon="arrow-left"
        />
        <div className="flex items-center justify-center text-white font-semibold bg-lime px-1 min-w-20">
          {MONTH_NAMES[selectedMonth]}
        </div>
        <BubbleButton
          block
          variant="lime"
          appearance="squared"
          onClick={nextMonth}
          icon="arrow-right"
        />
      </div>
    </div>
  );
};
